<div class="dropdown-label">{{ title }}</div>
<mat-form-field appearance="outline">
  <mat-select matNativeControl disableOptionCentering panelClass="icon-dropdown-panel" [(value)]="selected" (selectionChange)="selectedChange($event.value)">
    <mat-select-trigger>
      <div class="option-container">
        <div><app-svg-icon src="{{ selected?.iconPath }}"></app-svg-icon></div>
        <div class="label-default">{{ selected?.displayName }}</div>
      </div>
    </mat-select-trigger>
    <mat-option class="options" *ngFor="let option of options" [value]="option">
      <div class="option-container option-selection-container">
        <div class="icon"><app-svg-icon src="{{ option.iconPath }}"></app-svg-icon></div>
        <div class="label">{{ option.displayName }}</div>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
